module.exports = __webpack_public_path__ + "img/1557614087747215361.4df41d8f.png";